<template>
    <div>
        <input
            :type="inputType"
            :name="inputName"
            :placeholder="inputPlaceholder"
            :maxlength="inputMaxLength"
            :value="inputValue"
            :class="showErrorMessage ? 'border-red': 'border-black'"
            class="rounded-sm border w-full h-12 px-2 bg-white font-sans"
            @input="updateValue"
        >

        <p
            v-if="inputMessage"
            :class="{ 'text-red': messageError }"
            class="mt-2 text-xs"
        >
            {{ inputMessage }}
        </p>

        <transition name="cz3__fade">
            <p
                v-if="showErrorMessage"
                :class="{ 'font-bold': isKoreanInvalidMessage }"
                class="mt-2 text-xs text-red"
            >
                {{ errorMessage }}
            </p>
        </transition>
    </div>
</template>

<script>
    export default {
        props: {
            inputType: {
                type: String,
                default: 'text',
            },
            inputName: {
                type: String,
                required: true,
            },
            inputPlaceholder: {
                type: String,
                default: '',
            },
            inputValue: {
                type: String,
                default: '',
            },
            inputMessage: {
                type: String,
                default: '',
            },
            messageError: {
                type: Boolean,
                default: false,
            },
            inputMaxLength: {
                type: Number,
                default: null,
            },
            errorMessage: {
                type: String,
                default: '',
            },
            showErrorMessage: {
                type: Boolean,
                default: false,
            },
            isKoreanInvalidMessage: {
                type: Boolean,
                default: false,
            },
        },

        emits: ['input'],

        watch: {
            inputValue() {
            },
        },

        methods: {
            updateValue(v) {
                if (v.target.value.startsWith(' ')) {
                    v.target.value = v.target.value.trimStart();
                }

                this.$emit('input', v.target.value);
            },
        },
    };
</script>
